<template>
  <div>
    <div class="row" v-if="showGrid">
      <div class="col-md-12">

        <aron-table @selected="selected" uploadEndpoint="/uploadFile" endPoint="getMiscellReport"
          :filterEndpoint="filterEndpoint" key="getMiscellReport" :formType="formType"></aron-table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">

        <viewDetails @close="showGrid = true">
        </viewDetails>

      </div>
    </div>
  </div>
</template>

<script>
import AronTable from "@/components/aron/table/newMiscellTable.vue";
import viewDetails from "./viewDetails.vue";
//register vieDetails component

export default {
  components: {
    AronTable,
    viewDetails
  },
  computed: {
    filterEndpoint() {
      return "getMiscellReport";
    }
  },
  data() {
    return { showGrid: true, route: this.$route.params.endPoint, formType: "sidebarRightSide" };
  },
  methods: {
    selected(data) {
      this.showGrid = false;
      console.log(data);
    }
  }
};
</script>
